<template>
    <div class="title">
        <el-card>
            <el-row>
                <el-col :span="24">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
                    <el-breadcrumb-item>知识百科</el-breadcrumb-item>
                    <el-breadcrumb-item>百科审核</el-breadcrumb-item>
                </el-breadcrumb>
                </el-col>
            </el-row>
            <el-divider></el-divider>
            <el-row>
                <el-col :span="3">
                    <div class="demo-input-suffix fl">
                        <el-input size="small"
                            placeholder="请输入标题"
                            prefix-icon="el-icon-search"
                            v-model="title">
                        </el-input>
                    </div>
                </el-col>
                <el-col :span="2">
                    <el-button  icon="el-icon-setting" size="small" @click='search()' class="fl">搜索</el-button>
                </el-col>   
                <el-col :span="2">
                    <el-button type="primary" size="small" @click="Refresh" plain>刷新</el-button>
                </el-col>
                <el-col :span="17" style="text-align:right;">
                    <el-pagination  @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage" :page-sizes="[10,20,50,100]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper" :total="totalCount">
                    </el-pagination>
                </el-col>
            </el-row>
            <el-row>
                <el-table v-loading="loading" :data="tableData" stripe style="width: 100%" >
                    <el-table-column type="selection" width="50"></el-table-column>
                    <el-table-column prop="KnowledgeTitle" label="标题"></el-table-column>
                    <el-table-column prop="SendUserName" label="发送人" width="260"></el-table-column>
                    <el-table-column label="类型" width="260">
                    <template slot-scope="scope">{{ scope.row.Type==0?'添加':(scope.row.Type==1?'编辑':'未知') }}</template>
                    </el-table-column>
                    <el-table-column prop="SendTime" sortable label="发送时间"></el-table-column>
                    <el-table-column label="操作" style="width:20%;">
                    <template slot-scope="scope">
                        <el-button type="text" size="mini" @click='bindShadow(scope.row)'>查看</el-button>
                        <el-button type="text" size="mini" @click='bindCompare(scope.row)'>对比</el-button>
                        <el-button type="text" size="mini" @click='sendAudit(scope.row)'>审核通过</el-button>
                        <el-button type="text" size="mini" @click='setShadowID(scope.row)'>审核退回</el-button>
                    </template>
                    </el-table-column>
                </el-table>
            </el-row>
        </el-card>
    </div>    
</template>
<script>
     import { GetKnowledgeAuditPage,GetKnowledgeContentDescry,GetSingleKnowledgeShadow,UpdateKnowledgewShadow,UpdateKnowledgewAndShadow  } from "../../until/ZeusApiSDK/Logic/WikiLogic";
     import { Decrypt } from "../../until/ZeusApiSDK/Logic/CryptoLogic";  
     import { ImageAddDomain  } from "../../until/ZeusApiSDK/Logic/ImageStr";  
     import { timeFormate  } from "../../until/Common";
     export default {
        data() {
          return {
            totalCount:0,//默认数据总数
            pagesize:20,//每页的数据条数
            currentPage:1,//默认开始页面
            loading:true,
            input:"",
            title: '',
            currentRole:{},//当前角色
            currentUser:{},//当前用户
            content:'',//内容
            wikiShadowModel:{},//退回时获取百科影子数据信息
            //搜索下拉暂时不用
            // options: [{
            //     value: '选项1',
            //     label: '黄金糕'
            // }, {
            //     value: '选项2',
            //     label: '双皮奶'
            // }, {
            //     value: '选项3',
            //     label: '蚵仔煎'
            // }, {
            //     value: '选项4',
            //     label: '龙须面'
            // }, {
            //     value: '选项5',
            //     label: '北京烤鸭'
            // }],
            // value5: [],
            tableData: []
          };
        } ,
        methods: {
            tableRowClassName({row, rowIndex}) {
                if (rowIndex === 0) {
                return 'th';
                }
                return '';
            },
            //获取当前用户
            getCurrentUser:function(){
                var userinfo = window.sessionStorage.getItem("userinfo");
                userinfo = JSON.parse(Decrypt(userinfo));
                this.currentUser = userinfo;
            },
            //获取当前角色
            getCurrentRole:function(){
                var currentUserRole = window.sessionStorage.getItem("CurrentUserRole");
                this.currentRole = JSON.parse(Decrypt(currentUserRole));
            },
            //搜索数据
            search:function(){
                this.currentPage = 1;
                //重新获取数据
                this.getAuditList();
            },
            //刷新
            Refresh:function(){
                this.getAuditList();
            },
            //获取待审核列表
            getAuditList:async function(){
                this.loading=true;
                //构造参数
                var predicates=[
                {
                    Field:"IsDelete", 
                    Value:"0", 
                    Oper:"eq", 
                    IsAnd:1
                },{
                    Field:"AuditStatus", 
                    Value:"1", 
                    Oper:"in", 
                    IsAnd:1
                }];
                // //如果不是管理员显示本人发送
                if(this.currentRole.Key!='admin'){
                    predicates.push({Field:"SendUserID", Value:'132456', Oper:"eq", IsAnd:1 });
                } 
                //搜索条件是否为空      
                if (this.title!=null&&this.title!='')
                {
                    predicates.push({ Field:"KnowledgeTitle", Value:this.title, Oper:"contains", IsAnd:1 });
                }
                //获取待审核数据列表
                await GetKnowledgeAuditPage(predicates,this.currentPage,this.pagesize,'SendTime','desc').then(res=>{
                    this.totalCount=res.TotalCount;
                    this.tableData=res.DataList;
                    this.loading=false;
                });
            },
            //选择每页条数
            handleSizeChange(val) {
                this.currentPage = 1;
                this.pagesize = val;
                //重新获取列表数据
                this.getAuditList();
            },
            //跳转到第几页页面
            handleCurrentChange(val) {
                this.currentPage = val;
                //重新获取列表数据
                this.getAuditList();
            },
            //查看当前数据信息
            bindShadow:function(data){
                //跳转到查看详情页面
                this.$router.push('/Wiki/BindShadow?id='+data.ID);
            },
            //对比当前数据信息
            bindCompare:function(data){
                //跳转到对比公告页面
                this.$router.push('/Wiki/BindCompare?id='+data.ID+'&kid='+data.KnowledgeID);
            },
            //审核通过当前数据
            sendAudit:function(data){
                var id=data.ID;
                //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                this.$confirm('确定审核通过吗', '审核', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                }).then(() => {
                    //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                    GetSingleKnowledgeShadow(id).then(res=>{
                        this.wikiShadowModel=res;
                        var status=this.wikiShadowModel.AuditStatus;
                        this.wikiShadowModel.AuditUserID=this.currentUser.UserName;
                        this.wikiShadowModel.AuditUserName=this.currentUser.TrueName;
                        this.wikiShadowModel.AuditTime=timeFormate(new Date());
                        this.wikiShadowModel.AuditStatus=2;
                        //更新百科影子
                        UpdateKnowledgewAndShadow(this.wikiShadowModel.ID,this.wikiShadowModel).then(data=>{
                            if(data==true){
                                this.$message({
                                    type: 'success',
                                    message: '审核成功'
                                });
                                //获取待审核列表
                                this.getAuditList();
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: '审核失败'
                                });
                            }
                        });
                    });
                    
                }).catch(() => {
                    //取消    
                });
            },
            //审核退回当前数据
            setShadowID:async function(data){
                var id=data.ID;
                var status=data.AuditStatus;
                this.$prompt('退回原因', '审核退回', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消'
                }).then(({value}) => {
                    //提交
                    if(value==null||value==''){
                        this.$message({
                            type: 'error',
                            message: '请输入退回原因'
                        });
                        return false;
                    }
                    //获取当前数据信息(重新获取) 所有操作从新获取信息里面进行
                    GetSingleKnowledgeShadow(id).then(res=>{
                        this.wikiShadowModel=res;
                        var status=this.wikiShadowModel.AuditStatus;
                        this.wikiShadowModel.AuditUserID=this.currentUser.UserName;
                        this.wikiShadowModel.AuditUserName=this.currentUser.TrueName;
                        this.wikiShadowModel.AuditTime=timeFormate(new Date());
                        this.wikiShadowModel.AuditStatus=3;
                        this.wikiShadowModel.AuditNote=value;
                        //更新百科影子
                        UpdateKnowledgewShadow(this.wikiShadowModel.ID,this.wikiShadowModel).then(data=>{
                            if(data==true){
                                this.$message({
                                    type: 'success',
                                    message: '退回成功'
                                });
                                //获取待审核列表
                                this.getAuditList();
                            }else{
                                this.$message({
                                    type: 'error',
                                    message: '退回失败'
                                });
                            }
                        });
                    });
                    
                }).catch(() => {
                    //取消    
                });
            },
        },
        //页面进入加载事件
        created:function(){
            //获取当前用户
            this.getCurrentUser();
            //获取当前角色
            this.getCurrentRole();
            //获取待审核列表
            this.getAuditList();
        },
      };
</script>
<style lang="less" scoped>
    .fl{
        float: right;
        margin-right:20px;
    }
    .fy{
        text-align:center;
        margin-top:30px;
    }
    .title{
        height:100%;
    }
    .msgBox{
        width:60% !important;
        height:70%;
    }
</style>
